import React from "react";
import "./LoadingCircle.css";

const LoadingCircle = ({
  label = "Loading...",
  size = "large",
  fullScreen = true,
}) => {
  const containerClass = fullScreen
    ? "loading-container-full"
    : "loading-container-inline";
  const spinnerClass =
    size === "small" ? "loading-spinner-small" : "loading-spinner";

  return (
    <div className={containerClass}>
      <div className="loading-content">
        <div className={spinnerClass}></div>
        {label && <div className="loading-label">{label}</div>}
      </div>
    </div>
  );
};

export default LoadingCircle;
